// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"469":"15af50b9","837":"4c184137"}[chunkId] + ".chunk.css";
};